import { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { color } from '../ui/utils';

const MainNavigationLinkStyle = css`
  display: block;

  padding: ${({ theme }) => theme.spacing.baseUnit};
  text-align: center;

  text-decoration: none;
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: ${({ theme }) => theme.spacing.baseUp2};

  ${props => color(props.linkcolor)};

  &:hover {
    text-decoration: none;
  }

  &.active {
    span {
      box-shadow: 0 2px 0 ${({ theme, linkcolor }) => theme.colors[linkcolor]};
    }
  }

  ${breakpoint('tablet')`
    padding-top: ${({ theme }) => theme.spacing.baseDown2};
    padding-bottom: ${({ theme }) => theme.spacing.baseDown3};
    padding-left: ${({ theme }) => theme.spacing.baseDown1};
    padding-right: ${({ theme }) => theme.spacing.baseDown1};
    font-size: ${({ theme }) => theme.spacing.baseDown1};
    text-transform: uppercase;
  `};
`;

MainNavigationLinkStyle.defaultProps = {
  linkcolor: 'white',
};

export default MainNavigationLinkStyle;
